import { ApiError, api } from "./api";

export type Me = {
  id: string;
  name: string;
  email: string;
  twoFactorEnabled: boolean;
  isOwner: boolean;
  permissions: string[];
};

// The signed-in staff member, shared by the auth and access control providers. Kept briefly so
// a page render does not ask the API for every menu item; the API checks every request anyway.
const MAX_AGE_MS = 30_000;
let cache: { at: number; promise: Promise<Me | null> } | null = null;

export function loadMe(): Promise<Me | null> {
  if (cache && Date.now() - cache.at < MAX_AGE_MS) return cache.promise;
  const promise = api<Me>("/api/office/me").catch((error: unknown) => {
    if (error instanceof ApiError && error.statusCode === 401) return null;
    cache = null;
    throw error;
  });
  cache = { at: Date.now(), promise };
  return promise;
}

/** After signing in or out, setting up the second factor, or a 401 / 403 answer. */
export function clearMe(): void {
  cache = null;
}
